module.exports = "img/warning.05cc423.svg";